<tabset type="pills">
  <tab heading="Pills 1">Pills content 1</tab>
  <tab heading="Pills 2">Pills content 2</tab>
</tabset>
